<template>
  <div>
    <b-row>
      <h1>{{ $t("tripPlan.plural") }}</h1>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <router-link :to="'/workflow/pathCreate/'">
      <b-button size="sm">
        {{ $t("geral.create") }}
      </b-button>
    </router-link>

    <b-table
      ref="table"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            <div v-if="tableFilters[field.key] != null">
              <b-form-select
                v-if="field.key == 'active'"
                :options="booleanOpt"
                v-model="tableFilters[field.key]"
              >
              </b-form-select>
              <b-form-input
                v-else-if="field.key != 'actions'"
                v-model="tableFilters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(actions)="data">
        <!-- {{data.item}} -->
        <!-- <b-button size="sm" @click="openViewPath(data.item.imagePath)">
          Visualizar
        </b-button> -->
        <router-link :to="'/workflow/pathEdit/' + data.item.id">
          <b-button size="sm" class="ml-2">
            {{ $t("geral.edit") }}
          </b-button>
        </router-link>
        <router-link :to="'/workflow/pathCreate/' + data.item.id">
          <b-button size="sm" class="btn-checklist ml-2">
            {{ $t("geral.clone") }}
          </b-button>
        </router-link>
        <b-button
          v-if="data.item.active == true"
          size="sm"
          class="ml-2"
          @click="deleteTripPlan(data.item.id)"
        >
          {{ $t("geral.deactivate") }}
        </b-button>
        <b-button
          v-else
          size="sm"
          class="ml-2"
          @click="activeTripPlan(data.item.id)"
        >
          {{ $t("geral.activate") }}
        </b-button>
        <!-- <b-button size="sm" class="ml-2" @click="printTirpPlan(data.item.id)"
          >Impressão de exemplo</b-button
        > -->
      </template>
      <template v-slot:cell(active)="data">
        {{ data.value ? "Sim" : "Não" }}
      </template>
    </b-table>

    <view-path ref="viewPath"></view-path>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>
<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "ProcessPathList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    ViewPath: () => import("@/components_rms/workflow/Path/ViewPath.vue"),
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  data() {
    return {
      alert: {
        success: "",
        error: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          thStyle: { width: "300px", minWidth: "300px"  },
        },
        {
          key: "id",
          sortable: false,
          label: "Id",
          thStyle: { width: "100px", minWidth: "100px" },
        },
        {
          key: "name",
          sortable: false,
          label: "Nome plano viagem",
        },
        {
          key: "active",
          sortable: false,
          label: "Ativo",
          thStyle: { width: "100px", minWidth: "100px" },
        },
      ],
      tableFilters: {
        id: "",
        name: "",
        active: "true",
      },
      booleanOpt: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
    };
  },
  methods: {
    openViewPath(imagePath) {
      this.$refs.viewPath.show(imagePath);
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        id: ctx.filter.id,
        active: ctx.filter.active,
        pathName: ctx.filter.name,
      };
      this.$apiWorkflow
        .post("/tripPlan/list/", apiParam)
        .then((response) => {
          console.log(response.data.items);
          const items = response.data.items;
          console.log(items);
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    deleteTripPlan(tripPlanId) {
      this.$apiWorkflow
        .post("/tripPlan/delete/" + tripPlanId)
        .then((response) => {
          this.alert.success = "Plano de viagem desativado com sucesso";
          this.$refs.alert.show();
          this.$refs.table.refresh();
        });
    },
    activeTripPlan(tripPlanId) {
      this.$apiWorkflow
        .post("/tripPlan/active/" + tripPlanId)
        .then((response) => {
          this.alert.success = "Plano de viagem ativado com sucesso";
          this.$refs.alert.show();
          this.$refs.table.refresh();
        });
    },
    printTirpPlan(tirpPlanId) {
      this.$apiWorkflow
        .request({
          url: "/path/printTripPlan/" + tirpPlanId,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    cloneTripPlan(currentPlan) {
      this.copyTripPlan(currentPlan);
      this.$forceUpdate();
    },
  },
};
</script>
